export function pipe<TypeInput, TypeOutput>(
  ...functions: ((input: any) => any)[]
): (initial_input: TypeInput) => TypeOutput {
  return function (initial_input: TypeInput): TypeOutput {
    return <TypeOutput>functions.reduce((input: any, fn: (input: any) => unknown) => fn(input), initial_input);
  };
}
